export const state = () => ({
  cart: null,
})
export const mutations = {
  addCart(state, val) {
    state.cart = { ...val }
  },
}
